import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import RetailerHeader from "./RetailerHeader";
import RetailerSideMenu from "./RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { Link } from "react-router-dom";
import * as SecureLS from "secure-ls";
import constants from "../../constants";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class ViewRetailerCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
            { label: "Category Name", field: "category_name", sort: "asc", width: 180 },
            { label: "Description", field: "description", sort: "asc", width: 250 },
            { label: "Images", field: "images", sort: "asc", width: 120 },
            { label: "Status", field: "status", sort: "asc", width: 120 },
            { label: "Actions", field: "actions", sort: "asc", width: 120 },
          ],
        rows: [],
      },
    };
    this.deleteCategory = this.deleteCategory.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    let userData = ls.get("retuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/retailer/login";
    }
    this.fetchpagesdata(userData.retailer_id);
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //update status for category
  updateStatus(id, status) {
    // Use ActiveInactive API for status toggle (numeric: 1=active, 0=inactive)
    const newStatus = status === 1 ? 0 : 1;
    Httpconfig.httptokenput(
      Constant.siteurl + "api/productcategory/ActiveInactive/" + newStatus + "/" + id
    )
      .then((response) => {
        toast.success(response.data.message || "Successfully updated status");
        setTimeout(() => window.location.reload(), 2000);// Refresh table
      })
      .catch((error) => toast.error("Failed to update status"));
  }
  // For getting the data
  fetchpagesdata(entity_id) {
    Httpconfig.httptokenpost(
      constants.siteurl+"api/productcategory/categorylist",
      {
        page: 1,
        limit: 10,
        entity_id: entity_id
      }
    )
      .then((response) => {
        const categories = Array.isArray(response.data.data) ? response.data.data : [];
        let assignvalues = [];
  
        categories.forEach((cat) => {
          assignvalues.push({
            category_name: cat.category_name,
            description: cat.category_description,
            images: (
              <div style={{ display: "flex", gap: "4px" }}>
                {(cat.category_image || []).map((img, idx) => (
                  <img
                    key={idx}
                    src={img.url}
                    alt="Category"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" }}
                  />
                ))}
              </div>
            ),
            status: cat.status === 1 ? (
              <MDBBadge color="success" onClick={() => this.updateStatus(cat.id, cat.status)}>Active</MDBBadge>
            ) : (
              <MDBBadge color="warning" onClick={() => this.updateStatus(cat.id, cat.status)}>Inactive</MDBBadge>
            ),
            actions: (
              <div>
                <span>
                  <Link
                    to={"/retailer/RetailerCategories/" + cat.id}
                    className="fa fa-edit point-cursor"
                    title={"Edit " + cat.category_name}
                  />
                </span>
                &nbsp;
                <span>
                  <i
                    onClick={() => this.deleteCategory(cat.id, cat.category_name)}
                    className="fa fa-trash point-cursor"
                    title={"Delete " + cat.category_name}
                  />
                </span>
                &nbsp;
              </div>
            ),
          });
        });
  
        let categoryState = { ...this.state };
        categoryState.datatable.rows = assignvalues;
        this.setState(categoryState);
      })
      .catch((error) => toast.error("Failed to fetch categories"));
  }

  //delete controller
  deleteCategory(catId, name) {
    var isConfirm = window.confirm("Are you sure to delete " + name + "?");
    if (isConfirm) {
      Httpconfig.httptokendelete(Constant.siteurl + "api/productcategory/" + catId)
        .then((response) => {
          toast.success(response.data.message || "Successfully Deleted ");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => toast.error("Failed to delete category"));
    }
  }
  render() {
    const { datatable } = this.state;
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div className="Pharma_Content">
            <div className="container-fluid">
              <div className="create-coupon-page">
                <div className="row ">
                  <div className="col-md-12">
                    <form>
                      <div className="tab-header create-coupon-header">
                        <h3> Categories</h3>
                        <Link
                          to="/retailer/RetailerCategories"
                          className="btn  btn-primary fright"
                        >
                          Create Categories
                        </Link> 
                        </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div id="" class="viewcoupons">                          
                    {datatable.rows.length === 0 ? (
                      <p>No Categories found</p>
                    ) : (
                      <MDBDataTable
                        responsive
                        striped
                        bordered
                        small
                        data={datatable}
                      />
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="update_btn"
                          style={{ textAlign: "right" }}
                        ></div>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>
          </div>                 
        </section>
      </main>
    );
  }
}
